import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TComment } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetUsersAdminComments = async ({
  userID,
  limit
}: {
  userID: number;
  limit: number;
}): Promise<{
  data: {
    commentsRaw: TComment[];
    commentsNumber: number;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    commentsRaw: TComment[];
    commentsNumber: number;
  }>(`user/getAdminUserComments`, {
    userID,
    limit
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        commentsRaw: [
          {
            adminName: "",
            adminComment: "",
            commentDate: ""
          }
        ],
        commentsNumber: 0
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        commentsRaw: [
          {
            adminName: "",
            adminComment: "",
            commentDate: ""
          }
        ],
        commentsNumber: 0
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
